import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fe9db97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "cesium-container" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "geotimeline",
  class: "geotimeline"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_6 = { class: "current-time" }
const _hoisted_7 = { class: "info-content" }
const _hoisted_8 = { class: "info-head" }
const _hoisted_9 = { class: "info-title" }
const _hoisted_10 = { class: "info-detail" }
const _hoisted_11 = { class: "toolbtn speed" }
const _hoisted_12 = { class: "speed-popover" }
const _hoisted_13 = ["onClick"]

import { onMounted, ref, Ref, watch } from 'vue';
import * as Cesium from 'cesium';
import ZoomController from '@cesium-extends/zoom-control';
import { GeoTimeLine } from "@zjugis/geo-timeline";
import { ElMessage } from 'element-plus'

//import Graticule from "@/vendors/cesium/Graticule";
import Graticule from 'cesium-graticule';

//#region some hooks

export default /*#__PURE__*/_defineComponent({
  __name: 'AppView',
  setup(__props) {

function useViewer() {
    let zoom = ref<number>(0);
    const createViewer = (el: string) => {
        const viewer = new Cesium.Viewer(el, {
            navigationHelpButton: false,
            timeline: false,
            animation: false,
            fullscreenButton: false,
            shouldAnimate: false,
            skyBox: false,
            imageryProvider: false,
            sceneModePicker: false,
            geocoder: false,
            homeButton: false,
            baseLayerPicker: false,
            sceneMode: Cesium.SceneMode.SCENE3D,
            infoBox: false
        });


        //设置后当相机高度达到设置的最大和最小高度时将不再放大和缩小
		viewer.scene.screenSpaceCameraController.minimumZoomDistance = 3250000;//相机的高度的最小值
		viewer.scene.screenSpaceCameraController.maximumZoomDistance = 35000000;  //相机高度的最大值
		viewer.scene.screenSpaceCameraController._minimumZoomRate = 30000; // 设置相机缩小时的速率
		viewer.scene.screenSpaceCameraController._maximumZoomRate=5906376272000    //设置相机放大时的速率

        viewer.camera.setView({
            // destination: Cesium.Cartesian3.fromDegrees(116.4074, 39.9042, 20000000)
            destination: Cesium.Cartesian3.fromDegrees(0, 0, 20000000)
        });
        // const fullExtent = Cesium.Rectangle.fromDegrees(-180, -90, 180, 90);
        // viewer.camera.setView({
        //     destination: fullExtent
        // });

        // const defaultBaselayer = createDefaultBaselayer();
        // viewer.imageryLayers.addImageryProvider(defaultBaselayer);

        viewer.scene.backgroundColor = Cesium.Color.BLACK;
        viewer.cesiumWidget.scene.globe.baseColor = Cesium.Color.BLACK;
        (viewer.cesiumWidget.creditContainer as HTMLElement).style.display = 'none';
        //bug：在移动端无法显示底图，临时解决办法是关闭大气层，此bug已提交给cesium githubs
        viewer.scene.globe.showGroundAtmosphere = false;
        //优化字体显示
        viewer.scene.postProcessStages.fxaa.enabled = false;

        new ZoomController(viewer, {
            home: Cesium.Cartesian3.fromDegrees(116.4074, 39.9042, 0),
            tips: {
                zoomIn: "放大",
                zoomOut: "缩小"
            }
        });
        //监听moveEnd事件来实现zoom换算
        viewer.camera.moveEnd.addEventListener(() => {
            let height = Math.ceil(viewer.camera.positionCartographic.height);
            var A = 40487.57;
            var B = 0.00007096758;
            var C = 91610.74;
            var D = -40467.74;
            zoom.value = Math.round(D + (A - D) / (1 + Math.pow(height / C, B)));
        });
        return viewer;
    };
    return { createViewer, zoom };
}
function usePlayer() {
    let isPlaying: Ref<boolean> = ref(false);
    let speedPopoverVisible: Ref<boolean> = ref(false);
    let speed: Ref<number> = ref(10);
    let speeds: Ref<number[]> = ref([1, 2, 4, 8, 10, 16]);
    let time: Ref<number> = ref(250);
    let timer: Ref<number> = ref(0);
    const play = () => {
        isPlaying.value = true;
        timer.value = setInterval(() => {
            if (time.value <= 0) {
                stop();
            } else {
                time.value--;
            }
        }, 3000 / speed.value);
    };
    const stop = () => {
        clearInterval(timer.value);
        isPlaying.value = false;
    };
    const replay = () => {
        stop();
        time.value = 250;
        play();
    };
    watch(speed, (val) => {
        if (isPlaying.value) {
            stop();
            play();
        }
    });
    return {
        isPlaying, speedPopoverVisible, speed, speeds, time,
        replay, play, stop
    }
}
//底图图片
function useBaselayer(viewer: Ref<Cesium.Viewer | undefined>, zoom: Ref<number>, time: Ref<number>) {
    let layerCache = {};

    const changeBaseLineLayer = (t: number) => {
        let tag = `${zoom.value >= 4 ? '2000px' : 'v2'}/${t}`;
        if (layerCache[tag]) {
            viewer.value?.scene.imageryLayers.raiseToTop(layerCache[tag]);
            return;
        }
        t = t < 0 ? 0 : t;
        t = t > 250 ? 250 : t;
        let url = `/historical/${tag}.webp`;
        let layer = new Cesium.ImageryLayer(new Cesium.SingleTileImageryProvider({ url }), {});
        viewer.value?.imageryLayers.add(layer);
        layerCache[t] = layer;
    };
    watch(viewer, val => {
        //初始化底图
        val && changeBaseLineLayer(250);
    });
    watch(time, (val) => {
        changeBaseLineLayer(val);
    });
    watch(zoom, (newValue, oldValue) => {
        if (oldValue < 4 && newValue >= 4) {
            console.log('zoom change and changeBaseLineLayer');
            changeBaseLineLayer(time.value);
        }
        if (oldValue >= 4 && newValue < 4) {
            console.log('zoom change and changeBaseLineLayer');
            changeBaseLineLayer(time.value);
        }
    });
    //系统初始化时缓存底图

    onMounted(async () => {
        let cacheImg = (i: number) => {
            return new Promise<void>((resolve) => {
                let img = new Image();
                img.src = `/historical/v2/${i}.webp`;
                img.onload = () => {
                    resolve();
                };
            });
        };
        for (let i = 248; i < 250; i++) {
            await cacheImg(i);
        }
    });
}
function useMap23D(viewer: Ref<Cesium.Viewer | undefined>) {
    let map23d: Ref<2 | 3> = ref(3);
    const toggle23D = () => {
        if (map23d.value === 2) {
            map23d.value = 3;
            viewer.value?.scene.morphTo3D();
        } else {
            map23d.value = 2;
            viewer.value?.scene.morphTo2D();
        }
    };
    return {
        map23d,
        toggle23D,
        setTo3D() {
            map23d.value = 3;
            viewer.value?.scene.morphTo3D();
        }
    }
}
//当前位置
function useLocal(time: Ref<number>, viewer: Ref<Cesium.Viewer | undefined>, isPlaying: Ref<boolean>) {
    let isLocaling: Ref<boolean> = ref(false);
    let localLng: Ref<number> = ref(0);
    let localLat: Ref<number> = ref(0);
    let localCache = {};
    const drawMarker = (lng: number, lat: number) => {
        if (!isLocaling.value) {
            viewer.value?.entities.removeAll();
            return;
        }
        viewer.value?.entities.removeAll();
        viewer.value?.entities?.add({
            position: Cesium.Cartesian3.fromDegrees(lng, lat),
            point: {
                pixelSize: 10,
                color: Cesium.Color.RED,
            }
        }) || null;
        !isPlaying.value && viewer.value?.camera.setView({
            destination: Cesium.Cartesian3.fromDegrees(lng, lat, 20000000)
        });
    };
    const get_ancient_coordinates = () => {
        let params = {
            latitude: localLat.value,
            longitude: localLng.value,
            time: time.value
        };

        if (localCache[time.value]) {
            let { ancient_longitude, ancient_latitude } = localCache[time.value];
            drawMarker(ancient_longitude, ancient_latitude);
            return;
        }

        fetch("/get_ancient_coordinates", {
            body: JSON.stringify(params), method: "POST", headers: {
                "Content-type": "application/json",
            }
        }).then(res => res.json()).then(res => {
            localCache[time.value] = res;
            drawMarker(res.ancient_longitude, res.ancient_latitude);
        })
    };
    const getLocalPostion = () => {
        if (localLat.value && localLng.value) {
            get_ancient_coordinates();
            return;
        }
        navigator.geolocation.getCurrentPosition(position => {
            localLng.value = position.coords.longitude;
            localLat.value = position.coords.latitude;
            get_ancient_coordinates();
        }, err => {
            console.log(err);
        });
    };
    const onLocalBtnClick = () => {
        if (isLocaling.value) {
            isLocaling.value = false;
            viewer.value?.entities.removeAll();
        } else {
            isLocaling.value = true;
            getLocalPostion();
        }
    };
    watch(time, (val) => {
        isLocaling.value && getLocalPostion();
    });
    return { isLocaling, onLocalBtnClick };
}
function useTimeLine(time: Ref<number>, viewer: Ref<Cesium.Viewer | undefined>) {
    let currentTimeInfo: Ref<{ name?: string, desc?: string[] }> = ref({});
    let infoVisible = ref(false);

    let geoTimeLine: GeoTimeLine | null = null;

    let data = [];
    fetch('/GTS_2020_APP.json').then(res => res.json()).then(res => {
        data = res;
        currentTimeInfo.value = res[1];
        geoTimeLine = new GeoTimeLine("#geotimeline", res, {
            fontSize: 14,
            time: 250,
            maxZoom: 1,
            minZoom: 1,
            height: 70,
            showTick: false,
            limitHandle: true,
            onChange: function (_time, level) {
                time.value = +_time.toFixed(0);
                currentTimeInfo.value = data.find(o => o.leaf === true && _time <= o.start && _time >= o.end);
            },
        });
    });

    watch(time, (val) => {
        (geoTimeLine as any).time = val;
    });
    return { currentTimeInfo, infoVisible };
}
class CustomDate extends Date {
    addHours(hours: number): CustomDate {
        const date = new CustomDate(this.getTime());
        date.setHours(date.getHours() + hours);
        return date;
    }
    addDays(days: number): CustomDate {
        const date = new CustomDate(this.getTime());
        date.setDate(date.getDate() + days);
        return date;
    }
    format(fmt: string): string {
        var o = {
            'M+': this.getMonth() + 1, // 月份
            'd+': this.getDate(), // 日
            'h+': this.getHours(), // 小时
            'H+': this.getHours(), // 小时
            'm+': this.getMinutes(), // 分
            's+': this.getSeconds(), // 秒
            'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
            'S': this.getMilliseconds() // 毫秒
        }
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length ==
                1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
        return fmt
    }
}
function useAnnotation(time: Ref<number>, viewer: Ref<Cesium.Viewer | undefined>, zoom: Ref) {
    //洲、板块注记
    let czmlAnnotionLayer: any = null;
    const startTime = new CustomDate('2000-1-1 00:00:00').addHours(8);
    const _arr2czml = (arr: any[], labelStyle?: any) => {
        return arr.map((arr: any[], i: number) => {
            let [lng, lat, year, kind, name] = arr;
            let start = new CustomDate("1999-12-31").addDays(2 * year - 1).format('yyyy-MM-ddT00:00:00Z');
            let end = new CustomDate("1999-12-31").addDays(2 * year).format('yyyy-MM-ddT23:59:59Z');
            let item = {
                id: `annotation-${i}`,
                name,
                position: {
                    cartographicDegrees: [lng, lat, 0]
                },
                label: Object.assign({
                    text: name,
                    font: "bold 38px SimHei DroidSansFallback HarmonyOSSans",
                    fillColor: {
                        rgba: [255, 255, 255, 255]
                    },
                    outlineColor: {
                        rgba: [0, 0, 0, 255]
                    },
                    scale: 0.5,
                    outlineWidth: 6,
                    style: "FILL_AND_OUTLINE",
                    pixelOffset: {
                        cartesian2: [0, -9]
                    }
                }, labelStyle),
                availability: `${start}/${end}`
            };
            return item;
        });
    };

    watch(time, (newValue, oldValue) => {
        (viewer.value as Cesium.Viewer).clock.currentTime = Cesium.JulianDate.fromDate(startTime.addDays(2 * newValue - 1));
    });
    watch(viewer, (v) => {
        if (!v) {
            return;
        }
        fetch("/json/annotation.json").then(res => res.json()).then(res => {
            let czmlAnnotion = _arr2czml(res);
            let dataSourcePromise = Cesium.CzmlDataSource.load([{
                id: "document",
                name: "annotationCzmlDocument",
                version: "1.0",
                clock: {
                    currentTime: '2001-05-14T00:00:00Z',
                },
            }, ...czmlAnnotion]);
            dataSourcePromise.then((result) => {
                czmlAnnotionLayer = result;
                v.dataSources.add(result);
            });
        });
    });

    //页面加载时先把城市注记准备好，zoom>=4时才加载
    let cityCzmlAnnotionLayer: any = null;
    let isAdded = false;
    fetch("/json/annotation_city.json").then(res => res.json()).then(res => {
        let czmlAnnotion = _arr2czml(res, {
            font: "normal 34px SimHei DroidSansFallback HarmonyOSSans",
            outlineWidth: 4
        });
        let dataSourcePromise = Cesium.CzmlDataSource.load([{
            id: "document",
            name: "cityAnnotationCzmlDocument",
            version: "1.0",
        }, ...czmlAnnotion]);
        dataSourcePromise.then((result) => {
            cityCzmlAnnotionLayer = result;
            console.log(cityCzmlAnnotionLayer.show);
        });
    });
    watch(zoom, (val) => {
        if (val >= 4) {
            if (cityCzmlAnnotionLayer && !isAdded) {
                cityCzmlAnnotionLayer.clock.currentTime = (viewer.value as Cesium.Viewer).clock.currentTime;
                (viewer.value as Cesium.Viewer).dataSources.add(cityCzmlAnnotionLayer);
                isAdded = true;
            }
        } else {
            if (cityCzmlAnnotionLayer && isAdded) {
                (viewer.value as Cesium.Viewer).dataSources.remove(cityCzmlAnnotionLayer);
                isAdded = false;
            }
        }
    });
}
function useDEM(viewer: Ref<Cesium.Viewer | undefined>, time: Ref<number>, setTo3D) {
    let demTurnOn = ref(false);
    const setDEM = (t: number) => {
        (viewer.value as Cesium.Viewer).scene.globe.terrainExaggeration = 100.0;
        (viewer.value as Cesium.Viewer).scene.terrainProvider = new Cesium.CesiumTerrainProvider({
            url: '/terrains/' + t,
            requestWaterMask: true,
            requestVertexNormals: true
        });
    };
    const removeDEM = () => {
        (viewer.value as Cesium.Viewer).terrainProvider = new Cesium.EllipsoidTerrainProvider();
    };
    const toggleDEM = () => {
        demTurnOn.value = !demTurnOn.value;
        if (demTurnOn.value) {
            if(isPlaying.value){
                demTurnOn.value = false;
                ElMessage.info("请先停止播放再查看地形");
                return;
            }
            setTo3D();
            setDEM(time.value);
        } else {
            removeDEM();
        }
    };
    const closeDEM = () => {
        if(demTurnOn.value){
            demTurnOn.value = false;
            removeDEM();
        }
    };
    watch(time, val => {
        if (demTurnOn.value) {
            setDEM(val);
        }
    });
    watch(isPlaying,val=>{
        if(val){
            closeDEM();
        }
    });
    return { demTurnOn, toggleDEM };
}
//经纬网
function useGraticule(viewer: Ref<Cesium.Viewer | undefined>) {
    let GraticuleObj: any = null;
    let graticuleTurnOn = ref(false);
    const createGraticule = () => {
        GraticuleObj = new Graticule(viewer.value, {
            gridCount: 5,
            labelOptions: {
                fillColor: Cesium.Color.WHITE,
                font: 'bold 14px sans-serif',
                //font: "bold 42px SimHei DroidSansFallback HarmonyOSSans",
                outlineColor: Cesium.Color.BLACK,
                outlineWidth: 6
            },
            meridians: true,
            meridiansColor: Cesium.Color.YELLOW
        });
    };
    const toggleGraticule = () => {
        graticuleTurnOn.value = !graticuleTurnOn.value;
        if (graticuleTurnOn.value) {
            createGraticule();
        } else {
            GraticuleObj?.destory();
        }
    };
    //初始化
    watch(viewer, v => {
        if (!v) {
            return;
        }
        toggleGraticule();
    });
    return { graticuleTurnOn, toggleGraticule };
}
//#endregion

const cesiumViewer = ref<Cesium.Viewer>();
const { createViewer, zoom } = useViewer();

const { isPlaying, speedPopoverVisible, speed, speeds, time, play, stop, replay } = usePlayer();
const { infoVisible, currentTimeInfo } = useTimeLine(time, cesiumViewer);

useBaselayer(cesiumViewer, zoom, time);

const { map23d, toggle23D, setTo3D } = useMap23D(cesiumViewer);
const { onLocalBtnClick, isLocaling } = useLocal(time, cesiumViewer, isPlaying);
const { demTurnOn, toggleDEM } = useDEM(cesiumViewer, time, setTo3D);
const { graticuleTurnOn, toggleGraticule } = useGraticule(cesiumViewer);

useAnnotation(time, cesiumViewer, zoom);

let loadding = ref(true);
onMounted(() => {
    document.title = "深时古地形演化";
    cesiumViewer.value = createViewer('cesium-container');
    let timer = setTimeout(() => {
        loadding.value = false;
        clearTimeout(timer);
    }, 3500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "el-fade-in-linear" }, {
      default: _withCtx(() => [
        (_unref(loadding))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, "距今 " + _toDisplayString(_unref(time)) + " 百万年", 1),
    _createElementVNode("div", {
      class: "info",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (infoVisible.value = true))
    }),
    _createVNode(_Transition, { name: "el-fade-in-linear" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(currentTimeInfo)?.name), 1),
            _createElementVNode("i", {
              class: "info-close",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (infoVisible.value = false), ["stop"]))
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentTimeInfo)?.desc, (text, i) => {
              return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(text), 1))
            }), 128))
          ])
        ], 512), [
          [_vShow, _unref(infoVisible)]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["toolbtn latlng", { active: _unref(graticuleTurnOn) }]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toggleGraticule) && _unref(toggleGraticule)(...args)))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["toolbtn dem", { active: _unref(demTurnOn) }]),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(toggleDEM) && _unref(toggleDEM)(...args)))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["toolbtn map23d", { map2d: _unref(map23d) === 2 }]),
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(toggle23D) && _unref(toggle23D)(...args)))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["toolbtn local", { active: _unref(isLocaling) }]),
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(onLocalBtnClick)()))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["toolbtn play", { active: _unref(isPlaying) }]),
      onClick: _cache[6] || (_cache[6] = e => _unref(isPlaying) ? _unref(stop)() : _unref(play)())
    }, null, 2),
    _createElementVNode("div", {
      class: "toolbtn replay",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(replay)()))
    }),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        class: "current-speed",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (speedPopoverVisible.value = !_unref(speedPopoverVisible)))
      }, [
        _createTextVNode(" x" + _toDisplayString(_unref(speed)) + " ", 1),
        _createVNode(_Transition, { name: "el-fade-in-linear" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(speeds), (s) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: s,
                  onClick: ($event: any) => (speed.value = s)
                }, "x" + _toDisplayString(s), 9, _hoisted_13))
              }), 128))
            ], 512), [
              [_vShow, _unref(speedPopoverVisible)]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})